import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Contact() {
  const [contactData, setContactData] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getContact`)
      .then((response) => {
        setContactData(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, []);

  if (!contactData) {
    return <div>加載中 Loading...</div>;
  }

  return (
    
    <div className="page-content">
      <h2>聯絡我們</h2>
      <div dangerouslySetInnerHTML={{ __html: contactData.contact[0].content }} />      
    </div>
  );
}

export default Contact;
